var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEducator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496.2 496.2",
    style: {
      enableBackground: "new 0 0 496.2 496.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#32BEA6"
    },
    d: "M496.2,248.1C496.2,111.1,385.1,0,248.1,0S0,111.1,0,248.1s111.1,248.1,248.1,248.1 S496.2,385.1,496.2,248.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A379"
    },
    d: "M287,282.1h-77.8c12.1,36.6,1,53.3,1,53.3l26.9,6.1h22l26.9-6.1C286,335.4,274.9,318.7,287,282.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A379"
    },
    d: "M248.2,390.1c44.9,0,37.8-54.7,37.8-54.7s-8.9,17.3-38.1,17.3s-37.5-17.3-37.5-17.3 S203.3,390.1,248.2,390.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A379"
    },
    d: "M247.8,333.4c-77.2,0-139.1,22.1-146.4,49.3c-3.3,12.2-7,35.2-10.1,57.5 c42.7,34.9,97.4,55.9,156.9,55.9s114.1-21,156.9-55.9c-3.2-22.3-6.9-45.4-10.1-57.5C387.5,355.5,324.9,333.4,247.8,333.4z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#141414"
    },
    points: "349.1,408.1 147.1,408.1 159.8,153.1 335.2,132.6 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.1,
    y: 324.9,
    style: {
      fill: "#DEE0E2"
    },
    width: 86,
    height: 25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#295D66"
    },
    d: "M247.8,333.4c-77.2,0-139.1,22.1-146.4,49.3c-3.3,12.2-7,35.2-10.1,57.5 c42.7,34.9,97.4,55.9,156.9,55.9s114.1-21,156.9-55.9c-3.2-22.3-6.9-45.4-10.1-57.5C387.5,355.5,324.9,333.4,247.8,333.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADDE0"
    },
    d: "M293.9,336.2c-14.5-1.8-30-2.7-46.1-2.7c-15.9,0-31.2,0.9-45.5,2.7l45.8,91L293.9,336.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADDE0"
    },
    d: "M168.1,357.2l37-32.3l32,63.9c0,0-25.2,7.1-25.5,6.8L168.1,357.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DADDE0"
    },
    d: "M328.1,357.2l-37-32.3l-32,63.9c0,0,25.2,7.1,25.5,6.8L328.1,357.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A379"
    },
    d: "M248.1,412.1l-37.8-76.8c0,0,9.2-12.4,37.4-12.4s38.1,12.5,38.1,12.5L248.1,412.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2A379"
    },
    d: "M287,282.1h-77.8c12.1,36.6,1,53.3,1,53.3s16.4,6.1,37.9,6.1s37.9-6.1,37.9-6.1 S274.9,318.7,287,282.1z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B382"
    },
    d: "M327.9,175.2c0-92.4-35.7-113.6-79.8-113.6c-44,0-79.8,21.2-79.8,113.6c0,31.3,5.6,55.8,14,74.7 c18.4,41.6,50.3,56.1,65.8,56.1s47.3-14.5,65.8-56.1C322.3,231,327.9,206.5,327.9,175.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M288.7,71.1C272.5,54,237,58.7,237,58.7l0,0l0,0l0,0c-68.8,0-75.9,73.9-75.9,73.9l-1.3,20.5 c0,14.2,7.6,31.8,15,49.3c0,0-1.5-57.7,33.1-73.1s92.1-11.7,89.6-29.4C297.4,99,299,82.1,288.7,71.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M269.8,60.1c10.6-4.9,35.7,7.6,48.3,26.3c6.7,9.9,14.5,25,17.1,46.2c0,0,0.3,42.3-10.2,68.5 c0,0-30.2-87.3-63.1-124.6C262,76,263,63.3,269.8,60.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B382"
    },
    d: "M160.7,207.7c4.3,25.2,9.6,26.3,17.3,25l-8.1-54.8C162.2,179.3,156.4,182.6,160.7,207.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4B382"
    },
    d: "M326.5,178l-8.1,54.8c7.6,1.3,13,0.1,17.3-25C339.9,182.6,334.1,179.3,326.5,178z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC785E"
    },
    d: "M274.8,263.8c0,0-14.2,9.6-26.7,9.6s-26.7-9.6-26.7-9.6c0-1.4,11.3-5.3,16.1-6 c3-0.5,10.6,2.5,10.6,2.5s7.5-2.9,10.4-2.5C263.4,258.5,274.8,263.8,274.8,263.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C16952"
    },
    d: "M274.8,263.8c0,0-14.2,13.5-26.7,13.5s-26.7-13.5-26.7-13.5s6.5,1.5,19.6,0.7c2.2-0.1,5.1,1.6,7,1.6 c1.7,0,4.2-1.8,6.1-1.7C267.9,265.2,274.8,263.8,274.8,263.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#141414"
    },
    points: "186.6,194.6 172.6,193.9 173.2,191 187.1,191.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#141414"
    },
    points: "309.3,194.6 308.7,191.7 322.6,191 323.2,193.9  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M234.7,179.4h-45.9c-2.1,0-3.8,1.7-3.8,3.8v25.6c0,2.1,1.7,3.8,3.8,3.8h45.9c2.1,0,3.8-1.7,3.8-3.8 v-25.7C238.5,181.1,236.8,179.4,234.7,179.4z M232.8,204.6c0,1.7-1.3,3-3,3h-36.3c-1.7,0-3-1.3-3-3v-17c0-1.7,1.3-3,3-3h36.3 c1.7,0,3,1.3,3,3V204.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M307.4,179.4h-45.9c-2.1,0-3.8,1.7-3.8,3.8v25.6c0,2.1,1.7,3.8,3.8,3.8h45.9c2.1,0,3.8-1.7,3.8-3.8 v-25.7C311.2,181.1,309.5,179.4,307.4,179.4z M305.6,204.6c0,1.7-1.3,3-3,3h-36.3c-1.7,0-3-1.3-3-3v-17c0-1.7,1.3-3,3-3h36.3 c1.7,0,3,1.3,3,3V204.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#141414"
    },
    d: "M248,185.6c-11.2,0-12.3,6.9-12,10.4c-0.2,2.9,0.5,1.8,0.5,1.8c2.1-4.4,6.7-7.3,11.6-7.3 c4.9,0,9.4,2.9,11.6,7.3c0,0,0.7,1.1,0.5-1.8C260.3,192.5,259.2,185.6,248,185.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8D3BB"
    },
    d: "M305.6,204.6c0,1.7-1.3,3-3,3h-36.3c-1.7,0-3-1.3-3-3v-17c0-1.7,1.3-3,3-3h36.3c1.7,0,3,1.3,3,3 V204.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8D3BB"
    },
    d: "M232.8,204.6c0,1.7-1.3,3-3,3h-36.3c-1.7,0-3-1.3-3-3v-17c0-1.7,1.3-3,3-3h36.3c1.7,0,3,1.3,3,3 V204.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducator);
export default __webpack_public_path__ + "static/media/educator.b32cfa628262cea525341c6b42a9889a.svg";
export { ForwardRef as ReactComponent };